export const GET_ANNOTATIONS_REQUEST = "GET_ANNOTATIONS_REQUEST";
export const GET_ANNOTATIONS_SUCCESS = "GET_ANNOTATIONS_SUCCESS";
export const GET_ANNOTATIONS_FAILURE = "GET_ANNOTATIONS_FAILURE";

export const CREATE_ANNOTATION_REQUEST = "CREATE_ANNOTATION_REQUEST";
export const CREATE_ANNOTATION_SUCCESS = "CREATE_ANNOTATION_SUCCESS";
export const CREATE_ANNOTATION_FAILURE = "CREATE_ANNOTATION_FAILURE";

export const UPDATE_ANNOTATION_REQUEST = "UPDATE_ANNOTATION_REQUEST";
export const UPDATE_ANNOTATION_SUCCESS = "UPDATE_ANNOTATION_SUCCESS";
export const UPDATE_ANNOTATION_FAILURE = "UPDATE_ANNOTATION_FAILURE";

export const DELETE_ANNOTATION_REQUEST = "DELETE_ANNOTATION_REQUEST";
export const DELETE_ANNOTATION_SUCCESS = "DELETE_ANNOTATION_SUCCESS";
export const DELETE_ANNOTATION_FAILURE = "DELETE_ANNOTATION_FAILURE";

export const GET_MY_ANNOTATIONS_REQUEST = "GET_MY_ANNOTATIONS_REQUEST";
export const GET_MY_ANNOTATIONS_SUCCESS = "GET_MY_ANNOTATIONS_SUCCESS";
export const GET_MY_ANNOTATIONS_FAILURE = "GET_MY_ANNOTATIONS_FAILURE";

export const getAnnotationsRequest = (recordType, recordId, queryParams = {}) => ({
    type: GET_ANNOTATIONS_REQUEST,
    payload: { recordType, recordId, queryParams },
});

export const getAnnotationsSuccess = (recordKey, annotations) => ({
    type: GET_ANNOTATIONS_SUCCESS,
    payload: { recordKey, annotations },
});

export const getAnnotationsFailure = (error) => ({
    type: GET_ANNOTATIONS_FAILURE,
    payload: { error },
});

export const createAnnotationRequest = (recordType, recordId, annotationData) => ({
    type: CREATE_ANNOTATION_REQUEST,
    payload: { recordType, recordId, annotationData },
});

export const createAnnotationSuccess = (recordKey, annotation) => ({
    type: CREATE_ANNOTATION_SUCCESS,
    payload: { recordKey, annotation },
});

export const createAnnotationFailure = (error) => ({
    type: CREATE_ANNOTATION_FAILURE,
    payload: { error },
});

export const updateAnnotationRequest = (recordType, recordId, annotationId, annotationData) => ({
    type: UPDATE_ANNOTATION_REQUEST,
    payload: { recordType, recordId, annotationId, annotationData },
});

export const updateAnnotationSuccess = (recordKey, annotation) => ({
    type: UPDATE_ANNOTATION_SUCCESS,
    payload: { recordKey, annotation },
});

export const updateAnnotationFailure = (error) => ({
    type: UPDATE_ANNOTATION_FAILURE,
    payload: { error },
});

export const deleteAnnotationRequest = (recordType, recordId, annotationId) => ({
    type: DELETE_ANNOTATION_REQUEST,
    payload: { recordType, recordId, annotationId },
});

export const deleteAnnotationSuccess = (recordKey, annotationId) => ({
    type: DELETE_ANNOTATION_SUCCESS,
    payload: { recordKey, annotationId },
});

export const deleteAnnotationFailure = (error) => ({
    type: DELETE_ANNOTATION_FAILURE,
    payload: { error },
});

export const getMyAnnotationsRequest = (queryParams = {}) => ({
    type: GET_MY_ANNOTATIONS_REQUEST,
    payload: { queryParams },
});

export const getMyAnnotationsSuccess = (annotations) => ({
    type: GET_MY_ANNOTATIONS_SUCCESS,
    payload: { annotations },
});

export const getMyAnnotationsFailure = (error) => ({
    type: GET_MY_ANNOTATIONS_FAILURE,
    payload: { error },
});
